import { type FC } from 'react';
import { Table } from '@mantine/core';
import { type PayinOrder } from '~/entities/payin';
import { OrderRow, OrdersTableSkeleton } from './components';

const headers = [
    'ID',
    'Дата создания',
    'Трейдер',
    'Реквизиты',
    'Сумма',
    'Валюта',
    'Курс',
    'Статус',
    'До истечения',
    'Скопировать',
] as const;

interface OrdersTableProps {
    loading: boolean;
    orders?: PayinOrder[];
    onRowClick: (order: PayinOrder) => void;
}

export const OrdersTable: FC<OrdersTableProps> = ({ loading, orders, onRowClick }) => {
    return (
        <Table
            striped
            highlightOnHover
            stickyHeader
            aria-busy={loading}
        >
            {orders?.length === 0 && <Table.Caption>Ордеров нет</Table.Caption>}

            <Table.Thead>
                <Table.Tr>
                    {headers.map((header) => (
                        <Table.Th
                            key={header}
                            ta='center'
                        >
                            {header}
                        </Table.Th>
                    ))}
                </Table.Tr>
            </Table.Thead>

            <Table.Tbody>
                {loading ? (
                    <OrdersTableSkeleton columns={headers.length} />
                ) : (
                    orders?.map((order, index) => (
                        <OrderRow
                            key={order.id?.value ?? index}
                            order={order}
                            onClick={onRowClick}
                        />
                    ))
                )}
            </Table.Tbody>
        </Table>
    );
};
